var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@irati/utils/lang";
import RewardsQueryComponent from "@irati/reward/apollo/query/Rewards";
import tracking from "@irati-tracking/wallet/rewardWallet";
import { RewardStatus } from "@irati/reward/enums";
import { ButtonRouterLink } from "@irati/ui/src/Link";
var WalletHeaderBalanceButtons = /** @class */ (function (_super) {
    __extends(WalletHeaderBalanceButtons, _super);
    function WalletHeaderBalanceButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSendCredit = function () {
            tracking.startRewardWalletSendCredit();
        };
        _this.returnVariables = function () { return ({
            limit: 12,
            status: RewardStatus.ON,
            sortBy: "createdAt",
            sortDir: "DESC",
            rewardsForMyPackage: true,
            isCreditOnly: true
        }); };
        _this.returnCreditReward = function (_a) {
            var rewardCatalogueRewards = _a.rewardCatalogueRewards;
            var results = rewardCatalogueRewards.results;
            if (results.length > 0) {
                var creditReward = results[0];
                return creditReward;
            }
            return undefined;
        };
        return _this;
    }
    WalletHeaderBalanceButtons.prototype.render = function () {
        var _this = this;
        var apps = this.context.apps;
        return (React.createElement(React.Fragment, null,
            React.createElement(RewardsQueryComponent, { variables: this.returnVariables() }, function (res) {
                var creditReward = _this.returnCreditReward(res.data);
                if (creditReward) {
                    return (React.createElement(ButtonRouterLink, { primary: true, marginBottom: true, to: "/reward/" + creditReward.urlSlug, app: apps.RECOGNITION, onClick: _this.handleSendCredit },
                        React.createElement(FormattedMessage, { id: "wallet.reward.sendCreditAsReward.button" })));
                }
                return null;
            }),
            React.createElement(ButtonRouterLink, { onClick: tracking.clickBrowseRewards, to: "/reward/all", app: apps.RECOGNITION },
                React.createElement(FormattedMessage, { id: "wallet.reward.browseRewards.button" }))));
    };
    WalletHeaderBalanceButtons.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return WalletHeaderBalanceButtons;
}(PureComponent));
export default WalletHeaderBalanceButtons;
